import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React, { Fragment } from "react";
import styles from "../../../../Admin/MasterSetting/PositionMaster/PositionMasterEligibility/CommonMapEligibilityTable/CommonMapEligibilityTable.module.scss";
import DOMPurify from "dompurify";

const EligiblityComparisonCommonTable = ({
  tableHeader = [],
  tableData = [],
  consolidatedData = {},
}: any) => {
  const getLetterFromIndex = (index: any) => {
    let letter = "";
    while (index >= 0) {
      letter = String.fromCharCode((index % 26) + 65) + letter;
      index = Math.floor(index / 26) - 1;
    }
    return letter;
  };

  function formatValue(value: any) {
    // if (!value) {
    //   return "NA";
    // }
    const num = parseFloat(value);
    if (num === 0) return "0";
    return num % 1 === 0 ? num.toString() : num.toFixed(2);
  }

  return (
    <Box sx={{ width: "100%" }}>
      <TableContainer component={Paper} className={styles.tableContainer} sx={{boxShadow:'none'}}>
        <Table aria-label="simple table">
          <TableHead className={styles.tableHead}>
            <TableRow className={styles.rowHeader}>
              {tableHeader?.headerColumns?.map((header: any, index: any) => (
                <TableCell
                  key={index}
                  align={
                    header == "Max Marks" || header == "Candidate Marks"
                      ? "center"
                      : "left"
                  }
                >
                  <Typography variant="h6" className={styles.headerCell}>
                    {header}
                  </Typography>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody className={styles.tableBody}>
            <Fragment>
              {tableData?.map((values: any, index: any) => {
                return (
                  <TableRow>
                    <TableCell sx={{ padding: "25px" }} width={"5%"}>
                      {getLetterFromIndex(index)}
                    </TableCell>
                    <TableCell width={"65%"}>
                      <Typography
                        variant="body1"
                        className={styles.rowQualification}
                        sx={{
                          fontSize: "13px",
                          fontWeight: 400,
                          padding: 0,
                          color: "black",
                        }}
                        gutterBottom
                      >
                        {values?.description || "NA"}
                      </Typography>
                      {values?.subText && (
                        <Typography
                          variant="body1"
                          className={styles.rowDataLight}
                          sx={{
                            fontSize: "13px",
                            fontWeight: 400,
                            width: "32rem",
                            marginTop: "0.6rem",
                          }}
                          gutterBottom
                        >
                          <div
                            dangerouslySetInnerHTML={{
                              __html: DOMPurify.sanitize(values?.subText),
                            }}
                          />
                        </Typography>
                      )}
                    </TableCell>
                    <TableCell
                      width={"15%"}
                      align="center"
                      sx={{ fontWeight: "600", fontSize: "13px" }}
                    >
                      {formatValue(values?.max_marks)}
                    </TableCell>
                    <TableCell
                      width={"15%"}
                      align="center"
                      sx={{ fontWeight: "600", fontSize: "13px" }}
                    >
                      {formatValue(values?.candidate_marks)}
                    </TableCell>
                  </TableRow>
                );
              })}
              {consolidatedData?.totalMaxMarks && (
                <>
                <TableRow>
                  <TableCell sx={{ padding: "35px" }} width={"5%"}  style={{ backgroundColor: "#f6f6f6" }}></TableCell>
                  <TableCell sx={{fontWeight:"600"}}  style={{ backgroundColor: "#f6f6f6" }}>{"Total Marks"}</TableCell>
                  <TableCell
                    width={"15%"}
                    align="center"
                    sx={{ fontWeight: "700", fontSize: "13px" }}
                    style={{ backgroundColor: "#f6f6f6" }}
                  >
                    {formatValue(consolidatedData?.totalMaxMarks)}
                  </TableCell>
                  <TableCell
                    width={"15%"}
                    align="center"
                    sx={{ fontWeight: "700", fontSize: "13px" }}
                    style={{ backgroundColor: "#f6f6f6" }}
                  >
                    {formatValue(consolidatedData?.totalCandidateMarks)}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ padding: "35px" }} width={"5%"}  style={{ backgroundColor: "#f6f6f6" }}></TableCell>
                  <TableCell  style={{ backgroundColor: "#f6f6f6" }} sx={{fontWeight:"600"}}>{"Consolidated Percentage"}</TableCell>
                  <TableCell
                    width={"15%"}
                    align="center"
                    sx={{ fontWeight: "700", fontSize: "13px" }}
                    style={{ backgroundColor: "#f6f6f6" }}
                  >
                   
                  </TableCell>
                  <TableCell
                    width={"15%"}
                    align="center"
                    sx={{ fontWeight: "700", fontSize: "13px" }}
                    style={{ backgroundColor: "#f6f6f6" }}
                  >
                    {`${formatValue(consolidatedData?.consolidatedPercentage)} %`}
                  </TableCell>
                </TableRow>
                </>
              )}
            </Fragment>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default EligiblityComparisonCommonTable;
